import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { pushModal, resetModals } from "../../../store/slices/modalsSlice";
import GeneralCTAModal from "../../Modals/GeneralCTAModal";
import styles from "./TutorLiveScreen.module.css";

const Student = ({
  studentId,
  studentName,
  revokeSpeakingPermission,
  kickoutStudent,
  allowToSpeak,
}: {
  studentId: number;
  studentName: string;
  revokeSpeakingPermission: (id: number) => Promise<void>;
  kickoutStudent: (id: number) => Promise<void>;
  allowToSpeak: (id: number) => Promise<void>;
}) => {
  const { hands_raised, allowed_to_speak, active_mics } = useAppSelector(
    (state) => state.liveSession
  );
  const dispatch = useAppDispatch();

  return (
    <div className={styles.student}>
      <p className={styles.studentName}>
        {Array.isArray(studentName?.split(" "))
          ? studentName.split(" ").slice(0, 2).join(" ")
          : studentName}
      </p>
      <div className={styles.studentActions}>
        {hands_raised.includes(studentId) &&
          !allowed_to_speak.includes(studentId) && (
            <span
              className={styles.studentHandRaise}
              onClick={() => allowToSpeak(studentId)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="#1c4d57"
                className="bi bi-person-raised-hand"
                viewBox="0 0 16 16"
              >
                <path d="M6 6.207v9.043a.75.75 0 0 0 1.5 0V10.5a.5.5 0 0 1 1 0v4.75a.75.75 0 0 0 1.5 0v-8.5a.25.25 0 1 1 .5 0v2.5a.75.75 0 0 0 1.5 0V6.5a3 3 0 0 0-3-3H6.236a1 1 0 0 1-.447-.106l-.33-.165A.83.83 0 0 1 5 2.488V.75a.75.75 0 0 0-1.5 0v2.083c0 .715.404 1.37 1.044 1.689L5.5 5c.32.32.5.754.5 1.207" />
                <path d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
              </svg>
            </span>
          )}
        {allowed_to_speak.includes(studentId) && (
          <button
            className={`${
              active_mics.includes(studentId) ? styles.active : ""
            }`}
            onClick={() => {
              if (!hands_raised.includes(studentId)) return;
              revokeSpeakingPermission(studentId);
            }}
          >
            {active_mics.includes(studentId) ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="white"
                className="bi bi-mic"
                viewBox="0 0 16 16"
              >
                <path d="M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5" />
                <path d="M10 8a2 2 0 1 1-4 0V3a2 2 0 1 1 4 0zM8 0a3 3 0 0 0-3 3v5a3 3 0 0 0 6 0V3a3 3 0 0 0-3-3" />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="#1c4d57"
                className="bi bi-mic-mute fw-bold"
                viewBox="0 0 16 16"
              >
                <path d="M13 8c0 .564-.094 1.107-.266 1.613l-.814-.814A4 4 0 0 0 12 8V7a.5.5 0 0 1 1 0zm-5 4c.818 0 1.578-.245 2.212-.667l.718.719a5 5 0 0 1-2.43.923V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 1 0v1a4 4 0 0 0 4 4m3-9v4.879l-1-1V3a2 2 0 0 0-3.997-.118l-.845-.845A3.001 3.001 0 0 1 11 3" />
                <path d="m9.486 10.607-.748-.748A2 2 0 0 1 6 8v-.878l-1-1V8a3 3 0 0 0 4.486 2.607m-7.84-9.253 12 12 .708-.708-12-12z" />
              </svg>
            )}
          </button>
        )}
        <button
          className={styles.studentKickoutBtn}
          onClick={() =>
            dispatch(
              pushModal(
                <GeneralCTAModal
                  msg="هل انت متأكد من حذف الطالب ؟"
                  yesMsg="نعم"
                  noMsg="إلغاء"
                  yesHandler={async () => {
                    await kickoutStudent(studentId);
                    dispatch(resetModals());
                  }}
                  closeOnClick={true}
                />
              )
            )
          }
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="white"
            className="bi bi-x"
            viewBox="0 0 16 16"
          >
            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Student;
